<template>
  <div>
    <Modal :title="title" v-model="isShow" fullscreen :footer-hide="!canExport">
      <Table ref="maxTable" v-if="isShow" :data="data" :columns="columns" />
      <div slot="footer" v-if="canExport">
        <Poptip
          style="margin-left: 10px"
          confirm
          title="请确认是否导出?"
          @on-ok="exportData"
          ok-text="确认"
          cancel-text="取消"
          placement="top-start">
          <Button icon="ios-download-outline">导出表格</Button>
        </Poptip>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'max-table',
  props: {
    canExport: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      title: '',
      isShow: false,
      data: [],
      columns: []
    }
  },
  methods: {
    showModal (data, columns, title) {
      if (this.isShow === false) {
        this.data = data
        this.title = title
        this.columns = columns
        this.isShow = true
      }
      console.log(data, title, columns, this.isShow)
    },
    // 导出
    exportData () {
      this.$refs.maxTable.exportCsv({
        filename: `${this.title}-${(new Date()).valueOf()}.csv`
      })
    }
  }
}
</script>

<style>

</style>
